import Cookie from 'js-cookie';
import store from '../../store/index';

export default function loginGuard(to, from, next) {
    const userData = Cookie.get('userData');
    if (userData) store.commit('setUserData', JSON.parse(userData));
    if (!store.state.userData) return next('/login');
    return next();
}
